import React from 'react';
import PropTypes from 'prop-types';
import { Typography, colors } from 'kangarootime-ui';

const RoomInitialsLabel = ({ groupColor, ...props }) => {
  return (
    <div
      className='flex'
      style={{
        height: 24,
        width: 24,
        borderRadius: 12,
        justifyContent: 'center',
        backgroundColor: '#FFFFFF'
      }}
    >
      <Typography
        style={{
          color: groupColor,
          fontSize: '0.75rem',
          textAlign: 'center',
          fontWeight: 600
        }}
      >{props.children}</Typography>
    </div>
  );
};

RoomInitialsLabel.propTypes = {
  groupColor: PropTypes.string
};

RoomInitialsLabel.defaultProps = {
  groupColor: colors.brand_4
};

export default RoomInitialsLabel;
